import { Users, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function About() {
  const { t } = useTranslation();

  return (
    <section className="bg-gray-50 px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h2 className="text-4xl font-light tracking-tight">{t('about.title')}</h2>

        <div className="space-y-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-3">
              <Users size={20} className="text-gray-700" />
              {t('about.mission_title')}
            </h3>
            <p className="text-gray-700 font-light leading-relaxed">
              {t('about.mission_text')}
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 flex items-center gap-3">
              <Heart size={20} className="text-gray-700" />
              {t('about.goals_title')}
            </h3>
            <ul className="space-y-3 text-gray-700 font-light">
              <li className="flex gap-3">
                <span className="text-gray-900 mt-1">•</span>
                <span>{t('about.goal_1')}</span>
              </li>
              <li className="flex gap-3">
                <span className="text-gray-900 mt-1">•</span>
                <span>{t('about.goal_2')}</span>
              </li>
              <li className="flex gap-3">
                <span className="text-gray-900 mt-1">•</span>
                <span>{t('about.goal_3')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}